import { render, staticRenderFns } from "./Avancar.vue?vue&type=template&id=6ef2e9b7"
import script from "./Avancar.vue?vue&type=script&lang=js"
export * from "./Avancar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports